import { render, staticRenderFns } from "./PrintComanda.vue?vue&type=template&id=58fdb0b9&scoped=true&"
import script from "./PrintComanda.vue?vue&type=script&lang=js&"
export * from "./PrintComanda.vue?vue&type=script&lang=js&"
import style0 from "./PrintComanda.vue?vue&type=style&index=0&id=58fdb0b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fdb0b9",
  null
  
)

export default component.exports